import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=04dc535b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc535b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dc535b')) {
      api.createRecord('04dc535b', component.options)
    } else {
      api.reload('04dc535b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=04dc535b&scoped=true&", function () {
      api.rerender('04dc535b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rtsNhqkbXw1G/JS/comp/SearchFilterTokens.vue"
export default component.exports